import { X } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { View } from "tamagui";
import { ImageFit } from "../../../ui/ImageFit";
import { Modal } from "../../../ui/Modal";
import { Title } from "../../../ui/Title";

export const FeedFormImage: React.FC<{
  imageSrc: string;
  onRemove?: () => void;
}> = observer(({ imageSrc, onRemove }) => {
  const { t } = useTranslation();
  const [previewVisible, setPreviewVisible] = useState(false);
  const onClose = useCallback(() => {
    setPreviewVisible(false);
  }, []);
  const open = useCallback(() => {
    setPreviewVisible(true);
  }, []);

  return (
    <>
      <View position="relative" width={128} onPress={open} cursor="pointer">
        {onRemove && (
          <View
            position="absolute"
            top={-6}
            right={-6}
            zIndex={10}
            width={26}
            height={26}
            borderRadius={13}
            backgroundColor={"$pressablePrimaryBackground"}
            onPress={onRemove}
            justifyContent="center"
            alignItems="center"
          >
            <X color="$pressablePrimaryLabel" size={16} />
          </View>
        )}

        <ImageFit
          borderRadius={"$space.medium"}
          assetUrl={imageSrc}
          borderWidth={1}
          borderColor={"$divider"}
        />
      </View>

      <Modal
        modalId={`preview-${imageSrc}`}
        onClose={onClose}
        visible={previewVisible}
        header={
          <View paddingHorizontal={"$larger"} paddingTop={"$medium"}>
            <Title>{t("feed_image_preview")}</Title>
          </View>
        }
        noPadding
      >
        <ImageFit assetUrl={imageSrc} />
      </Modal>
    </>
  );
});
